import { FunctionComponent } from "react"
import {PanelsType} from "types"

export const Panel: FunctionComponent<PanelsType> = (props) => {
    return (
        <div 
        className={`panel ${props.active ? `is-${props.active}` : ''}`}
        >
            {props.children}
        </div>
    )
}

export const PanelSummary = (props) => {

    return (
        <div className="panel__summary">
            {props.children}
       </div>
    )
}
export const PanelSummaryLeft = (props) => {

    return (
        <div className="panel__summary-left">
            {props.children}
       </div>
    )
}
export const PanelSummaryRight = (props) => {

    return (
        <div className="panel__summary-right">
            {props.children}
       </div>
    )
}
export const PanelSummaryTitle = (props) => {

    return (
        <div className="panel__summary-title">
            {props.children}
       </div>
    )
}
export const PanelSummaryDetails = (props) => {

    return (
        <div className="panel__summary-details">
            {props.children}
       </div>
    )
}

export const PanelBody = (props) => {

    return (
        <div className="panel__body">
            {props.children}
       </div>
    )
}